import detectIncognito from 'detectincognitojs'
import { useEffect, useState } from 'react'
import { getFingerprint } from 'src/components/CustomHooks/useFingerprint'
import { SHOW_FREE_SEARCH } from 'src/config/config'
import { useSearchSolutionsLazyQuery } from 'src/graphql/generated/hooks'

import useSearchQuery from './SearchQuery'

type Filters = {
  keyword?: string
  audiences?: string[] | null
  practiceAreas?: string[] | null
  languages?: string[] | null
  deployments?: string[] | null
  regionsServed?: string[] | null
  topic?: string[] | null
  hqs?: string[] | null
  attributes?: string[] | null
  integrations?: string[] | null
}

export const useIncreaseSolutionCount = () => {
  const [loadSolutions, { loading, data, error }] = useSearchSolutionsLazyQuery()
  const [fingerprint, setFingerprint] = useState<string | null>(null)
  const [browser, setBrowser] = useState({ browserName: '', isPrivate: false })
  const { getSearchQuery } = useSearchQuery()
  const getfingerprintID = async (cancelExcution = false) => {
    if (cancelExcution) {
      return
    } else {
      const fingerprintID = await getFingerprint()
      setFingerprint(fingerprintID)
    }
  }

  useEffect(() => {
    getfingerprintID(!SHOW_FREE_SEARCH)
  }, [])

  useEffect(() => {
    detectIncognito().then((result: any) => {
      setBrowser(result)
    })
  }, [])

  const increaseSolutionCount = async (filters: Filters = {}, newProductType?: string) => {
    const baseQuery = {
      keyword: filters.keyword ?? null,
      audiences: filters.audiences ?? null,
      practiceAreas: filters.practiceAreas ?? null,
      languages: filters.languages ?? null,
      deployments: filters.deployments ?? null,
      attributes: filters.attributes ?? null,
      regionsServed: filters.regionsServed ?? null,
      subTopic: newProductType ?? null,
      hqs: filters.hqs ?? null,
      integrations: filters.integrations ?? null,
    }

    const customAccessQuery: string = getSearchQuery(filters, newProductType)
    const finalQuery =
      SHOW_FREE_SEARCH && fingerprint && fingerprint != null && customAccessQuery
        ? {
            ...baseQuery,
            accessFreeSearch: true,
            uniqueAddress: !browser?.isPrivate && browser?.browserName !== '' ? fingerprint.toString() : '0',
            customAccessQuery,
          }
        : baseQuery

    await loadSolutions({ variables: { query: finalQuery }, fetchPolicy: 'no-cache' })
  }

  return { increaseSolutionCount, loading, data, error }
}
